module.exports = __webpack_public_path__ + "img/image_dl.b1230264.png";